require('./bootstrap');
require('waypoints/lib/jquery.waypoints.min');
require('waypoints/lib/shortcuts/infinite.min');
require('./navigation');
require('./admin');
require('./general');
require('./components/tables');
